import { DialogueUIConfig, DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType } from "../CalmBaseScenario";
import Scenario5 from "./Scenario5";

export default class Scenario5Part2 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 0;
	chapterIds = {
		
		scenario5_4A_s14: 'CALM - Scenario 5 - 4A - Segment 14',
		scenario5_3B_s15: 'CALM - Scenario 5 - 3B - Segment 15',
		scenario5_4B_s16: 'CALM - Scenario 5 - 4B - Segment 16',
	}

	constructor(scenario: Scenario5, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario5/calm-scenario5-avatar' + this.scenario.avatarIndx + '.mp4'];
	}
	public get partId(): string {
		return constants.scenarios.scenario5.parts.level5Part5.id;
	}

	public start() {
		const context = this;
		context.segment1Step1MarcoApproaches();

	}

	private segment1Step1MarcoApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.displayHeader();
		context.segment1Step2Dialogue();
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C10-S1-000a',
			[{
				text: 'Go ahead and discharge him. He’s good to go.',
				feedback: 'You chose to have the patient discharged. Let\'s assume you asked Marco to check his vital signs to make sure the patient is healthy.',
				scoreType: ScoreType.Zero,
				isCorrect: false // Rank Zero
			}, {
				text: 'First take his vital signs. We need to be sure he\'s healthy.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best_s
			}],
			(selectedOption: DialogueUIOptionConfig, config: DialogueUIConfig) => {
				context.scenario.evaluateAnswer_s(selectedOption, () => {
					context.segment2Step1AfterResponse();
				}, () => {
					context.segment2Step1AfterResponse();
					}
				)
				context.scenario.evaluateAnswerForSummative(selectedOption, {
					onOptionSelected: () => { },
					options: [
						{
							text: 'Go ahead and discharge him. He’s good to go.',							
							scoreType: ScoreType.Zero,
							isCorrect: false // Rank Zero
						}, {
							text: 'First take his vital signs. We need to be sure he\'s healthy.',
							scoreType: ScoreType.Best,
							isCorrect: true // Rank best_s
						}
					],
					aarScenarioID: 2,
					aarSectionID: 0,
					aarCollectionID: [config.selectedAnswer]
				}, () => { }, context.partIndx)
			}
		);
		context.scenario.updateObjective('Select your response to Marco');
	}

	private segment2Step1AfterResponse() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario5_4A_s14, () => {
			this.segment2Step2Ben();
		});
		context.scenario.updateObjective('');
	}
	
	private segment2Step2Ben() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario5_3B_s15, () => {
			this.segment2Step3MarcoAgain();
		});
		context.scenario.updateObjective('');
	}

	
	private segment2Step3MarcoAgain() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario5_4B_s16, () => {
			this.onDone();
		});
		context.scenario.updateObjective('');
	}

}